import { Reservation } from '@/models/reservation';
import { Treatment } from '@/models/treatment';
import { Deserializable } from '@common/interfaces/deserializable';
import { Menu } from '@/models/menu';

export interface UserTreatmentCancelRequest {
  id: number;
  reason_code: string | null;
  reason_label: string | null;
  reason_text: string | null;
  created_at: string | null;
  reverted_at: string | null;
  executed_at: string | null;
}

export interface UserTreatmentInput {
  id: number;
  menu_id: number;
}

export class UserTreatment implements Deserializable<UserTreatment>, UserTreatmentInput {
  id!: number;
  menu_id: number;
  feedback_type: string;
  state: string;
  menu?: Treatment;
  plan?: { id: number; name: string };
  reservations?: Reservation[];
  handler_type: string;
  unread_message: number;
  reservation: Reservation; // Added reservation field
  latest_cancel_request?: UserTreatmentCancelRequest | null;
  // No.143 follow-up feature — backend-computed, see App\Models\UserTreatment
  // ::getIsFollowUpAttribute() (sheepmedical-api). Never derive on the frontend.
  is_follow_up?: boolean;
  consultation_type?: string;
  episode_number?: number;

  get onlyOneReservation() {
    return this.reservations ? this.reservations[0] : null;
  }

  deserialize(input: Partial<UserTreatmentInput>): UserTreatment {
    Object.assign(this, input);
    return this;
  }
}
